import {AxiosError} from 'axios'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useStaticPartsListQueryParams {
  plantUpmId: string
  kilnUpmId: string
  staticPartId: string
  shutdownId?: number
}

export const useStaticPartDetailQuery = ({
  plantUpmId,
  kilnUpmId,
  staticPartId,
  shutdownId
}: useStaticPartsListQueryParams) => {
  return useRefraQuery({
    queryKey: 'staticPartDetail',
    retry: false,
    params: [{plantUpmId, kilnUpmId, staticPartId, shutdownId}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useStaticPartDetailQuery')
        .extras({errorDetails, plantUpmId, kilnUpmId})
        .error('Error occurred while fetching static part detail.')

      return false
    }
  })
}
